import { Plus, Search } from "lucide-react";
import { useTranslation } from "react-i18next";

type Props = {
  query: string;
  onQueryChange: (value: string) => void;
  onNewConnection: () => void;
};

const MCPToolbar = ({ query, onQueryChange, onNewConnection }: Props) => {
  const { t } = useTranslation();
  return (
    <div className="flex items-center gap-4">
      <h1 className="text-xl font-semibold text-foreground">
        {t("mcpPage.title")}
      </h1>

      <div className="relative flex flex-1 items-center">
        <Search className="absolute start-3 size-4 text-muted-foreground" />
        <input
          type="text"
          placeholder={t("mcpPage.search")}
          value={query}
          onChange={(e) => onQueryChange(e.target.value)}
          className="h-10 w-full max-w-md rounded-md border border-border bg-card ps-9 pe-3 text-sm text-foreground outline-hidden transition-colors placeholder:text-muted-foreground focus:border-primary"
        />
      </div>

      <button
        type="button"
        onClick={onNewConnection}
        className="flex h-10 items-center gap-2 rounded-md bg-primary px-5 text-sm font-semibold text-primary-foreground transition-all hover:brightness-110"
      >
        <Plus className="size-4" />
        {t("mcpPage.newConnection")}
      </button>
    </div>
  );
};

export default MCPToolbar;
